import React, {PropTypes as T} from 'react';

const ClearIcon = ({ width = 24, height = 24, color, className = '' }) => (
  <svg
    aria-label="Clear Icon"
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    width={width}
    height={height}
    className={`icon__clear ${className}`}>
    <path style={{fillRule: 'evenodd'}}
      d="M11 9.727L7.394 6.121 6.12 7.394 9.727 11l-3.606 3.606 1.273 1.273L11 12.273l3.606
      3.606 1.273-1.273L12.273 11l3.606-3.606-1.273-1.273L11 9.727zM11 22c6.075 0 11-4.925 11-11
      S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11zm0-2a9 9 0 1 0 0-18 9 9 0 0 0 0 18z" />
  </svg>
);

ClearIcon.propTypes = {
  width: T.number,
  height: T.number,
  color: T.string,
  className: T.string
};

export default  ClearIcon;



// WEBPACK FOOTER //
// ./frontend/react/components/common/icons/icon_clear.js